
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import moment from "moment";
import { useAuthState } from "../../../../../../../../Helper/Context";
import { ViewSchedulingGetTableDataAPI } from "../../../../../../../../Redux/EnchrochmentDashboardSlice/ViewScedulingSlice/CreateNewSchedulingSlice";
import { Loading } from "../../../../../../../../Helper/Loading";
import { HeaderIllegal } from "../../../../IllegalConstructionDashboard/HeaderIllegal";
import EnchrochmentSidebar from "../../../EnchrochmentSidebar/EnchrochmentSidebar";
import { ZoneNameCommanDDL } from "../../../../../../../../Components/IllegalDDL/ZoneNameCommanDDL";
import { WardNameDDL } from "../../../../../../../../Components/IllegalDDL/WardNameDDL";
import { Pegination } from "../../../../../../../../Components/Pegination/Pegination";
import { WardGridPopup } from "./WardGridPopup";
import { AreaGridPopup } from "./AreaGridPopup";
import PathakNamePopUp from "../ClosedComplaintEnchrochmentGrid/Modal/PathakNamePopUp";

export const TodaySchedulingGrid = () => {

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails

    const { t } = useTranslation()

    const [searchParams] = useSearchParams()

    // let YearValue = searchParams.get("YearValue")
    // let MonthValue = searchParams.get("MonthValue")
    // let ZoneValue = searchParams.get("ZoneValue");
    let DashSelect = searchParams.get("DashSelect");
    let Flag = searchParams.get("Flag");
    const ScreenNameTotal = searchParams.get('ScreenNameTotal')

    const [IsPost, setIsPost] = useState(false)

    const [IsClear, setIsClear] = useState(false)
    const [IsSearch, setIsSearch] = useState(false)

    const [PerPageCount, setPerPageCount] = useState(10)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = useState('')
    const [showImagePopup, setshowImagePopup] = useState(false)

    const [FromDate, setFromDate] = useState(moment().format('YYYY-MM-DD'))
    const [ToDate, setToDate] = useState('')

    const [GridData, setGridData] = useState([])

    // ------------header DDL ------------

    const [YearValue, setYearValue] = useState(sessionStorage.getItem('yearId'))
    const [YearLabel, setYearLabel] = useState(sessionStorage.getItem('yearLable'))
    const [MonthValue, setMonthValue] = useState(sessionStorage.getItem('monthId'))
    const [MonthLabel, setMonthLabel] = useState(sessionStorage.getItem('monthLable'))
    const [ZoneValue, setZoneValue] = useState(sessionStorage.getItem('zoneId'))
    const [ZoneLabel, setZoneLabel] = useState(sessionStorage.getItem('ZoneLable'))

    const [isopen, setIsOpen] = useState(false);
    const toggle = () => {
        setIsOpen(!isopen);
    };

    const [PathakDetails, setPathakDetails] = useState(false)

    const handlePathakDetails = (data) => {
        setPathakDetails(!PathakDetails)
        setGridData(data)
    }

    const [WardPopup, setWardPopup] = useState(false)

    const handleWardPopup = (data) => {
        setGridData(data)
        setWardPopup(!WardPopup)
    }

    const [AreaPopup, setAreaPopup] = useState(false)

    const handleAreaPopup = (data) => {
        setGridData(data)
        setAreaPopup(!AreaPopup)
    }
    // ----------------Track PopUp ----------------

    const [TrackPopUpShow, setTrackPopUpShow] = useState(false)

    const handleTrack = () => {
        setTrackPopUpShow(!TrackPopUpShow)
    }


    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }

    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: sessionStorage.getItem('LanguageChange')
    })

    const [ZoneNameID, setZoneNameID] = useState({
        DDL: [],
        ID: ZoneValue && ZoneValue ? ZoneValue : '0',
        Label: ZoneLabel && ZoneLabel ? ZoneLabel : "Select...",
    })

    const [WardNameID, setWardNameID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }
    const handleClear = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsClear(!IsClear)
        setFromDate('')
        setToDate('')
        setZoneNameID({
            ...ZoneNameID,
            ID: 0,
            Label: 'Select...'
        })
        setWardNameID({
            ...WardNameID,
            ID: 0,
            Label: 'Select...'
        })
    }
    useEffect(() => {
        setCurrentPage(0)
        setFrom(1)
        setTo(10)
    }, [ZoneNameID.ID])

    useEffect(() => {
        const data = {
            M_FinacialYearID: YearValue,
            M_MonthID: MonthValue,
            FromDate: FromDate,
            ToDate: '',
            M_ZoneID: ZoneNameID.ID ? ZoneNameID.ID : ZoneValue,
            M_WardID: WardNameID.ID,
            T_Encroach_CreateSchedulingID: 0,
            M_WorkTypeID: DashSelect,
            Language: Language.Label,
            M_UserID: UserID,
            FromTop: From,
            ToTop: To,
            token: token,
            Flag: Flag,
        }
        if (Language.Label != null) {
            dispatch(ViewSchedulingGetTableDataAPI({ data }))
        }
    }, [YearValue, MonthValue, DashSelect, From, IsClear, IsSearch, IsPost, Language.Label, FromDate, ToDate, ZoneValue, ZoneNameID.ID, WardNameID.ID])

    const { isLoadingData, tableDataOne } = useSelector(state => state.ViewSchedulingGetTableData)

    function openFile(fileUrl) {

        if (fileUrl) {
            window.open(fileUrl, '_blank');
        } else {
            console.error('File URL is not provided.');
        }
    }

    return (
        <>
            {isLoadingData && <Loading />}
            <HeaderIllegal />
            <div className="wrapper bg-change">
                <EnchrochmentSidebar
                />
                <div className="content1 content mt-1 " style={{}}>

                    <div className="row">
                        <div className="col-12">
                            {/* Today’s Scheduling */}
                            <h5 className="text-dark fw-bold ps-3 pt-2 all_heading_fontsize">
                                {t('EncroachmentDashboard.TodaysScheduling')}
                            </h5>
                        </div>
                    </div>

                    <div className="row ps-3 py-2 eic_table_styles" >

                        <div class="col-12 col-lg-2 pt-2">
                            <label for="fname" className=" pb-2">{t('EncroachmentDashboard.date')}</label><br />
                            <input
                                className="form-control"
                                id="FromDate"
                                type="date"
                                name="FromDate"
                                value={FromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                                disabled
                            />
                        </div>

                        <div class="col-12 col-lg-3 pt-2">
                            <ZoneNameCommanDDL
                                ZoneNameID={ZoneNameID}
                                setZoneNameID={setZoneNameID}
                                Flag='Insert'
                                ApiFlag='UserWiseZone'
                                data=''
                                IsPost=''
                                Language={Language}
                                ZoneValue={ZoneValue}
                                ZoneLabel={ZoneLabel}
                            />
                        </div>

                        <div class="col-12 col-lg-3 pt-2">
                            <WardNameDDL
                                WardNameID={WardNameID}
                                setWardNameID={setWardNameID}
                                Flag='Insert'
                                ApiFlag='Master'
                                data=''
                                IsPost=''
                                Language={Language}
                                ZoneNameID={ZoneNameID}
                            />
                        </div>

                        <div className="col-12 col-lg-2 col-md-4  mt-3">
                            <button type="button" className="btn btn-danger mt-4" onClick={handleClear}>Clear</button>
                        </div>

                        <div className="row" >
                            <div className="col-12  " >
                                <div className="table-responsive pt-3">
                                    <table className="table table-striped table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="w-6 text-center">{t('EncroachmentDashboard.SrNo')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.OrderDate')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.OrderDay')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.OrderNumber')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ScheduleDate')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ScheduleDay')}</th>
                                                {
                                                    ScreenNameTotal == 'Completed Scheduling' &&
                                                    <>
                                                        <th className="text-center">{t('EncroachmentDashboard.CompletedDate')}</th>
                                                        <th className="text-center">{t('EncroachmentDashboard.CompletedDay')}</th>
                                                    </>

                                                }

                                                <th className="text-center">{t('EncroachmentDashboard.ZoneName')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.WardName')}</th>
                                                {/* <th className="text-center">{t('EncroachmentDashboard.Shift')}</th> */}
                                                <th className="text-center">{t('EncroachmentDashboard.ShiftTiming')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.workArea')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.Pathak')}</th>                                                         <th className="text-center">{t('EncroachmentDashboard.ScheduleOrder')}</th>
                                                {/* <th className="text-center">{t('EncroachmentDashboard.Report')}</th>
                                                            <th className="text-center">{t('EncroachmentDashboard.VehicleTracking')}</th> */}
                                            </tr>

                                        </thead>
                                        <tbody>

                                            {
                                                tableDataOne && tableDataOne.length > 0 ? tableDataOne.map((i, j) => {
                                                    return (
                                                        <tr>
                                                            <td className="py-1" align="center">{i.rowNum}</td>
                                                            <td className="nowrap">{i.orderDate ? moment(i.orderDate).format("DD-MM-YYYY") : '-'}</td>
                                                            <td >{i.orderDay ? i.orderDay : '-'}</td>
                                                            <td >{i.orderNumber ? i.orderNumber : '-'}</td>
                                                            <td className="nowrap">{i.scheduleDate ? moment(i.scheduleDate).format("DD-MM-YYYY") : '-'}</td>
                                                            <td >{i.scheduleDay ? i.scheduleDay : '-'}</td>
                                                            {
                                                                ScreenNameTotal == 'Completed Scheduling' &&
                                                                <>
                                                                    <td className="nowrap">{i.completedDate ? moment(i.completedDate).format("DD-MM-YYYY") : '-'}</td>
                                                                    <td >{i.completedDay ? i.completedDay : '-'}</td>
                                                                </>

                                                            }
                                                            <td className="nowrap"  >{i.zoneName ? i.zoneName : '-'}</td>
                                                            <td className="text-center">
                                                                <button className="button_popUp"
                                                                    onClick={() => handleWardPopup(i)}
                                                                >
                                                                    {/* {t('EncroachmentDashboard.Open')} */}
                                                                    Ward
                                                                </button>
                                                            </td>
                                                            {/* <td >{i.shiftName ? i.shiftName : '-'}</td> */}
                                                            <td className="nowrap" >{i.workTimeFrom ? i.workTimeFrom : '-'}<hr className="my-0" /> {i.workTimeTo ? i.workTimeTo : '-'}</td>
                                                            <td className="text-center">
                                                                <button className="button_popUp"
                                                                    onClick={() => handleAreaPopup(i)}
                                                                >
                                                                    {/* {t('EncroachmentDashboard.Open')} */}
                                                                    Area
                                                                </button>
                                                            </td>

                                                            <td className="text-center">
                                                                <button className="view_button"
                                                                    onClick={() => {
                                                                        handlePathakDetails(i)
                                                                    }}
                                                                >
                                                                    <td className="nowrap" >{i.pathakName ? i.pathakName : '-'}</td>
                                                                </button>
                                                            </td>
                                                            <td className="text-center cursor-pointer">
                                                                <span onClick={() => openFile(i.upload_Doc)}>
                                                                    <i class="fa-solid fa-file pt-2" style={{ fontSize: '20px' }}></i>
                                                                </span>
                                                            </td>

                                                        </tr>
                                                    )
                                                })
                                                    :
                                                    <tr>
                                                        <td colSpan={20}>No data found ...</td>
                                                    </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                {tableDataOne && tableDataOne.length > 0 &&
                                    <Pegination
                                        PerPageCount={PerPageCount}
                                        TotalCount={tableDataOne && tableDataOne[0].totalCount}
                                        setFrom={setFrom}
                                        setTo={setTo}
                                        CurrentPage={CurrentPage}
                                        setCurrentPage={setCurrentPage}
                                        IsClear={IsClear}
                                    />
                                }
                            </div>


                        </div>
                    </div>

                </div>
            </div>

            {
                WardPopup ?
                    <WardGridPopup
                        handleWardPopup={handleWardPopup}
                        heading={t('EncroachmentDashboard.WardName')}
                        Language={Language}
                        GridData={GridData}
                    /> : <></>
            }

            {
                AreaPopup ?
                    <AreaGridPopup
                        handleAreaPopup={handleAreaPopup}
                        heading={t('EncroachmentDashboard.workArea')}
                        Language={Language}
                        GridData={GridData}
                    /> : <></>
            }

            {
                PathakDetails ?
                    <PathakNamePopUp
                        handlePathakDetails={handlePathakDetails}
                        heading={t('EncroachmentDashboard.Pathak')}
                        gridData={GridData}
                        DashSelect={DashSelect}
                        YearValue={YearValue}
                        MonthValue={MonthValue}
                        ZoneValue={ZoneValue}
                        Flag='Pathak'
                        Language={Language}

                    /> : <></>
            }
        </>
    )
}

